<style src="css/scheduling.css" scoped></style>
<template>
    <div style="padding-top: 1rem;padding-bottom: .98rem">
        <div class="topbar-wrapper">
            <div class="topbar">
                <span class="back" @click="back"></span>
                排班设置
                <span class="help" @click="to(`help`)">帮助</span>
            </div>
        </div>
<!--        <topbar text="排班设置"></topbar>-->
        <div class="tabBox">
            <div class="tabType" :class="{actived:type===1}" @click="changeType(1)">按天设置</div>
            <div class="tabType" :class="{actived:type===2}" @click="changeType(2)">批量设置</div>
        </div>
        <div class="mainBox" v-if="type ===1">
            <div class="titleBox" >
                咨询方式：
            </div>
            <div class="consultingList"  v-if="doctorDetail.chatDoctorServe">
                <div class="consultingItem" :class="{active:doctorDetail.chatDoctorServe.video}" @click="select(doctorDetail.chatDoctorServe.video,2,'视频咨询')">
                    <div class="ciIcon ci1"></div>
                    <div class="selectBox">
                        视频咨询
                    </div>
                </div>
                <div class="consultingItem" :class="{active:doctorDetail.chatDoctorServe.telephone}" @click="select(doctorDetail.chatDoctorServe.telephone,1,'语音咨询')">
                    <div class="ciIcon ci2"></div>
                    <div class="selectBox">
                        语音咨询
                    </div>
                </div>
                <div class="consultingItem" :class="{active:doctorDetail.chatDoctorServe.imageText}" @click="select(doctorDetail.chatDoctorServe.imageText,0,'图文咨询')">
                    <div class="ciIcon ci3"></div>
                    <div class="selectBox">
                        图文咨询
                    </div>
                </div>
                <div class="consultingItem" :class="{active:doctorDetail.chatDoctorServe.offline}" @click="select(doctorDetail.chatDoctorServe.offline,3,'线下咨询')">
                    <div class="ciIcon ci4"></div>
                    <div class="selectBox">
                        线下咨询
                    </div>
                </div>
            </div>
            <div class="titleBox">
                咨询时间：（每次咨询为50分钟）
            </div>
            <div class="timeBox" v-if="doctorDetail.chatDoctorSchedules">
                <div class="item" v-for="item in doctorDetail.chatDoctorSchedules">
                    <div class="timeItem" :class="{active:JSON.parse(item.dateValue).length>0,active2:item.scheduleId===scheduleId}" @click="selectDateTime(item.scheduleId)">
                        <div :class="{timeItemStatus:JSON.parse(item.dateValue).length>0,timeItemStatusActive:item.scheduleId===scheduleId}"></div>
                        {{item.scheduleDate | week}}
                        <span>{{item.scheduleDate | MM}}</span>
                    </div>
                    <div class="itemBlock" v-for="v in JSON.parse(item.dateValue)">{{v}}</div>
                </div>

            </div>
        </div>
        <div class="mainBox" v-if="type ===2">
            <div class="titleBox">
                咨询时间：
            </div>
            <div class="timeBox" v-if="weekScheduleList">
                <div class="item" v-for="item in weekScheduleList">
                    <div class="timeItem" :class="{active:JSON.parse(item.dateValue).length>0,active2:item.scheduleId===scheduleId}" @click="selectDateTime(item.scheduleId)">
                        <div :class="{timeItemStatus:JSON.parse(item.dateValue).length>0,timeItemStatusActive:item.scheduleId===scheduleId}"></div>
                        {{item.type | isWeek}}
                    </div>
                    <div class="itemBlock" v-for="v in JSON.parse(item.dateValue)">{{v}}</div>
                </div>

            </div>
        </div>
        <div class="bottomBox active" v-if="scheduleId" @click="to(`timeSetting?scheduleId=${scheduleId}&type=${type}`)">
              修改时间
        </div>
        <div class="bottomBox" v-else>
                选择日期
        </div>
    </div>
</template>
<script>
    import {getSource, getSources} from "../api"

    import noMoreData from 'components/no-more-data'
    import topbar from 'components/topbar'
    import moment from 'moment/moment'
    import eventBus from '../eventBus';
    import {Swiper, Slide} from 'vue-swiper-component';
    import {serialize} from 'utils/index'

    export default {
        data() {
            return {
//                EnvUrl: `https://oml9ntix5.qnssl.com/`, // 七牛图片
                EnvUrl: `https://cdn.ysqingxin.com/`,
                doctorId:'',
                doctorDetail:{},
                serveType:'',
                name:'',
                scheduleId:'',
                type: 1,
                weekScheduleList:[]
            }
        },
        components: {
            noMoreData,
            topbar,
            Swiper,
            Slide,
        },
        filters: {
            time(value) {
                let transTime = moment(value).format('YYYY-MM-DD HH:mm:ss')
                return transTime
            },

            MM(value){
                let transTime = moment(value).format('MM-DD')
                return transTime
            },
            isWeek(v){
                let arr = ['','周一','周二','周三','周四','周五','周六','周日']
                return arr[v]
            },
            week(value) {
                let time = moment(value).format('dddd');
                let obj = {
                    'Monday':'周一',
                    'Tuesday':'周二',
                    'Wednesday':'周三',
                    'Thursday':'周四',
                    'Friday':'周五',
                    'Saturday':'周六',
                    'Sunday':'周日'
                }
                return obj[time]
            }
        },
        computed: {},
        methods: {
          // activated(){
          //   //根据key名获取传递回来的参数，data就是map
          //   eventBus.$on('type', function(data){
          //     //赋值给首页的附近医院数据模型
          //     this.type = data;
          //     if(data){
          //       this.changeType(parseInt(data))
          //     }
          //   }.bind(this));
          // },
            back() {
                history.back()
            },
            changeType(n){
                this.type = n;
                if(n===1){
                    this.getDoctorScheduleToBespeak()
                }else{
                    this.getDoctorWeekSchedule()
                }
            },
            selectDateTime(n){
                this.scheduleId = n;
            },
            getDate(value) {
                let transTime = moment(value).format('YYYY-MM-DD')+' '
                return transTime
            },
            select(a,b,c){
                if(a){
                    this.serveType = b;
                    this.name = c;
                }
            },
            async getDoctorScheduleToBespeak() {
                let obj = {}
                obj.doctorId = this.doctorId;
                obj.type = 1;
                let data = await getSources("/bear-scale/api/chatDoctor/getDoctorScheduleToBespeak.json", obj);
                if (data.status === 0) {
                    this.doctorDetail=data.doctorSchedule
                }else{
                    alert(data.msg)
                }
            },
            async getDoctorWeekSchedule() {
                let obj = {}
                obj.doctorId = this.doctorId;
                let data = await getSources("/bear-scale/api/chatDoctor/getDoctorWeekSchedule.json", obj);
                if (data.status === 0) {
                    this.weekScheduleList=data.weekScheduleList
                }else{
                    alert(data.msg)
                }
            },
            to(n) {
                this.$router.push(`/${n}`)
            },
        },
        destroyed(){

        },
        mounted() {
            this.doctorId = localStorage.getItem('doctorId')
            // this.activated()
            if(this.$route.query.type){
                this.changeType(parseInt(this.$route.query.type))
            }else{
                this.getDoctorScheduleToBespeak()
            }


        }
    }
</script>



// WEBPACK FOOTER //
// src/components/scheduling.vue